var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Sidebar'),_c('div',{staticClass:"ml-16 d-flex align-center flex-column"},[_c('v-container',{staticClass:"mx-10 d-flex align-center flex-column"},[_c('Topbar'),_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }